"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = void 0;
const browser_monads_1 = require("browser-monads");
// returns either Desktop or Mobile
function getDeviceType() {
    const h = browser_monads_1.window?.screen?.height ?? 0;
    const w = browser_monads_1.window?.screen?.width ?? 0;
    const isMobile = Math.min(h, w) < 480 && (browser_monads_1.window?.navigator?.userAgent ?? '').indexOf('Mobi') > -1;
    return (isMobile) ? 'Mobile' : 'Desktop';
}
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=windowScreenSize.js.map